module.exports = __webpack_public_path__ + "static/img/Fetty_Wap.dccd337.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/card/Fetty_Wap.jpg
// module id = IWa4
// module chunks = 1